import { pluralize } from '@travelata-libs/utils';

const NIGHTS_FORMS = ['ночь', 'ночи', 'ночей'];

export function nightsWord(n: number): string {
  return pluralize(NIGHTS_FORMS, n, false);
}

export function formatNightsRange(from: number, to: number, dash = '-'): string {
  if (from === to) {
    return `${from} ${nightsWord(from)}`;
  }
  return `${from}${dash}${to} ${nightsWord(to)}`;
}
